/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import styles from '../styles/Home.module.css';
import { useEffect, useState } from 'react';
import { CallbackType, FRAuth,  FRLoginFailure, FRLoginSuccess, FRStep, StepType } from '@forgerock/javascript-sdk';
import Loading from '../components/02-molecules/Loading';
import { trees } from '../config';
import { IStageProgressBadge, StageProgressBadge } from '../components/layout/StageProgressBadge';
import FROutputCallbackBasedView from '../components/forms/common/FROutputCallBackBasedView';
import SuspendMessage from '../components/forms/common/SuspendMessage.tsx';
// import { cloneDeep, isNil } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import { getInitialStageItems, getStageHeader } from '../util/generalUtility';
import SelectMFAMethod from '../components/forms/Login/selectMFAMethod';
import RegisterAppQR from '../components/forms/Login/registerAppQR';
import ValidateCode from '../components/forms/common/ValidateCode';
import FormLayout from '../components/layout/form';
import { MessageType } from '../components/modals/SuccessErrorModal';
import AcceptTermsAndConditions from '../components/forms/common/AcceptTermsAndConditions';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../redux/hooks';
import { setLoginRequested, toggleLogin } from '../redux/loginSlice';


const SAML = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [step, setStep] = useState<FRStep | FRLoginFailure | FRLoginSuccess | null>(null);
    const [tree, setTree] = useState(trees.samlLogin);
    const [stageItems, setStageItems] = useState<IStageProgressBadge[]>([]);
    const [goto, setGoto] = useState('');
    const [redirectUI, setRedirectUI] = useState('')
    const[stageHeaderList,setStageHeaderList] = useState<{name:string,stageName:string}[]>([])
    const [messageType, setMessageType] = useState(MessageType.info);
  const [message, setMessage] = useState('');  
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  
    useEffect(() => {
      (async function getStep() {
        const goto = new URLSearchParams(window.location.search).get('goto') || '';
        setGoto(new URLSearchParams(window.location.search).get('goto') || '')
        const stepString = sessionStorage.getItem('step')
      const code = sessionStorage.getItem('mfacode')
      const state = sessionStorage.getItem('mfastate')
      let step;
      if(!!stepString){
          step =JSON.parse(stepString).payload;
      }
      setRedirectUI(new URLSearchParams(window.location.search).get('redirectUi') || '')
      if(!!!step){
        try {
       
          
            const initialStep = await FRAuth.start({ tree, query: {goto} });
          if(initialStep && initialStep.type===StepType.Step){
            initialStep.callbacks.forEach((callback, i) => {  
              const type = callback.getType()  
             if (type === CallbackType.RedirectCallback) {
          
            if (callback.getOutputValue('trackingCookie')) {
              // save current step information for later resumption of tree.
              sessionStorage.setItem('authIndexValue', tree);
              sessionStorage.setItem('step', JSON.stringify(initialStep));
              sessionStorage.setItem('realm', 'PnW');              
              localStorage.setItem(FRAuth.previousStepKey,JSON.stringify(initialStep))
            }
            const redirectUrl = callback.getOutputValue('redirectUrl') as string;
            if (callback.getOutputValue('redirectMethod') === 'POST') {
              const redirectData = callback.getOutputValue('redirectData') as string;
              const form = document.createElement('form');
              form.method = 'post';
              form.action = redirectUrl ;
  
              Object.entries(redirectData as string).forEach(([key, value]) => {
                const hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = key;
                hiddenField.value = value;
  
                form.appendChild(hiddenField);
              });
  
              document.body.appendChild(form);
              form.submit();
            } else {
              window.location.href = redirectUrl;
            }
            return;
          }
        })
          }
          setStep(initialStep);
          
        } catch (err) {
          console.error(`Error: request for initial step; ${err}`);
        }
      }
      else
      {
        let authIndexType = new URLSearchParams(window.location.search).get('authIndexType') || ''
        let authIndexValue = new URLSearchParams(window.location.search).get('authIndexValue') || '' 
        if ( authIndexType === 'service' && authIndexValue !== '')
        {          
        setTree(authIndexValue)          
        const nextStep= await FRAuth.resume(window.location.href) 
        if(nextStep && nextStep.type===StepType.Step){
          setStageHeaderList(getStageHeader(nextStep));
          setStageItems(getInitialStageItems(nextStep,getStageHeader(nextStep)));        
        }
        setStep(nextStep);
        }
      }

    })();

    return () => {
      sessionStorage.removeItem('mfacode');
      sessionStorage.removeItem('mfastate');
      sessionStorage.removeItem('step');
    };
    }, []);

    useEffect(() => {
      (async () => {
        if (step && step.type === StepType.LoginSuccess) {
          if (goto && goto != null && goto != '' && goto != undefined) {
            window.location.replace(goto)
            sessionStorage.removeItem('mfacode');
            sessionStorage.removeItem('mfastate');
            sessionStorage.removeItem('step');
          }
          else {
  
            if (redirectUI && redirectUI != null && redirectUI != '' && redirectUI != undefined) {
              // localStorage.clear();
              // sessionStorage.clear();
              sessionStorage.removeItem('mfacode');
              sessionStorage.removeItem('mfastate');
              sessionStorage.removeItem('step');
              //await TokenManager.getTokens();
              navigate(redirectUI)
            } else {
              // await TokenManager.getTokens();
              sessionStorage.removeItem('mfacode');
              sessionStorage.removeItem('mfastate');
              sessionStorage.removeItem('step');
              navigate('/dashboard');
            }
            dispatch(setLoginRequested(true))
  
  
          }
        }
      })();
    }, [step, navigate]);

    useEffect(() => {
      if(!isNil(step) && step && step.type === StepType.Step)
        updateStageItems(step.getStage())      
  },[step]);
  
    const updateStageItems =(stage: string | undefined) => {
      const stageItemForUpdate = cloneDeep(stageItems);
      if(step && step.type===StepType.Step){
        stageHeaderList?.forEach((value:{name:string,stageName:string},index:number)=>{
          if(stageItemForUpdate[index].className==='active'){
            stageItemForUpdate[index].className='completed';
          }
            if(stage===value.stageName){
              stageItemForUpdate[index].className='active';
            }
            
        })
        // This logic is for back button clicks 
      stageItemForUpdate?.reverse().every((v:any,index:number)=>{
        if (stageItemForUpdate[index].className==='disabled')
        {
          return true;
        } else if(stageItemForUpdate[index].className==='active')
        {
          return false;
        }
        else if(stageItemForUpdate[index].className==='completed')
        {
          stageItemForUpdate[index].className='disabled'
          return true;
        }
    })
      }
      // setStageItems(stageItemForUpdate);
      let stageItemForUpdatefinal=stageItemForUpdate.reverse();
      setStageItems(stageItemForUpdatefinal);
    }
  
  
    const getContinueRegistrationView = () => {
      let uiElement: JSX.Element = <Loading size={100} />;
      if (step && step.type === StepType.Step) {
        switch (step.getStage()) {
          case "GetEmail":
          case 'ResetPassword':  
            uiElement = (
              <>
                {" "}
                <StageProgressBadge key={1} items={stageItems} />
                <FROutputCallbackBasedView
                  step={step as FRStep}
                  setStep={setStep}
                  tree={tree}
                  messageType={messageType}
                  setMessageType={setMessageType}
                  message={message}
                  setMessage={setMessage}
                  isAlertOpen={isAlertOpen}
                  setIsAlertOpen={setIsAlertOpen}
                />
              </>
            );
            break;
          case "SelectCompany":
          case "RegistrationForm":
          case "Account":
            sessionStorage.removeItem('mfacode');
            sessionStorage.removeItem('mfastate');
            sessionStorage.removeItem('step');
            uiElement = (
              <>
                {" "}
                <StageProgressBadge key={1} items={stageItems} />
                <FROutputCallbackBasedView
                  step={step as FRStep}
                  setStep={setStep}
                  tree={tree}
                  messageType={messageType}
                  setMessageType={setMessageType}
                  message={message}
                  setMessage={setMessage}
                  isAlertOpen={isAlertOpen}
                  setIsAlertOpen={setIsAlertOpen}
                />
              </>
            );
            break;
          case "TermsAndConditions":
            uiElement = (
              <>
                {" "}
                <StageProgressBadge key={1} items={stageItems} />
                <AcceptTermsAndConditions
                  step={step as FRStep}
                  setStep={setStep}
                  tree={tree}
                  messageType={messageType}
                  setMessageType={setMessageType}
                  message={message}
                  setMessage={setMessage}
                  isAlertOpen={isAlertOpen}
                  setIsAlertOpen={setIsAlertOpen}
                />
              </>
            );
            break;

          case "SuspendMessage":
            sessionStorage.removeItem("mfacode");
            sessionStorage.removeItem("mfastate");
            sessionStorage.removeItem("step");
            uiElement = <SuspendMessage step={step as FRStep} />;
            // navigate('/login')
            break;
        }
      } else if (step && step.type === StepType.LoginFailure) {
        uiElement = (
          <>
            {" "}
            <FormLayout
              header={"Error"}
              subHeader={step.payload.message}
              button={<></>}
            ></FormLayout>
          </>
        );
        //setUpIntialStep(step.payload.message || '');
      }
      return uiElement;
    };
  
    const setUpIntialStep = async (message: string) => {
      //const initialStep = await FRAuth.start({ tree });
      //setStep(initialStep);
      setIsAlertOpen(true);
      setMessage(message)
  
    }
  
    //  step.getStage() returns the stage name that is defined on page nodes within the FR tree
    return (
      <div className={styles.container}>
  
        <main className={styles.main}>
          {getContinueRegistrationView()}
        </main>
        {/*  <footer  className={styles.footer}>
          <Footer/>
        </footer> */}
      </div>
    );
  };
  
  export default SAML;
  